import { ReactComponent as MenuIcon } from "../../../../assets/icons/menu-icon.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/icons/search-dark.svg";
import { ReactComponent as BellIcon } from "../../../../assets/icons/bells.svg";
import Avatar from "../../../../assets/images/avatar.png";
import { auth, logout } from "../../../../services/firebase";
import { LOGIN_ROUTE } from "../../../../routes";

const DashboardNavbar = ({ toggleHandler, history, aXNzdXBlcmFkbWlu, currentOrg, orgList, setCurrentOrg,userName="" }) => {
    const dashboardHeight = 64;

    const navButtonStyle = {
        width: "32px",
        height: "32px",
        flexBasis: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    return (
        <div
            id="dashboard-navbar"
            className="position-relative shadow-sm ui-1"
            style={{ height: dashboardHeight + "px", zIndex: "100" }}
        >
            <div className="d-flex p-3 h-100">
                <div className="btn p-0" onClick={() => toggleHandler()} style={navButtonStyle}>
                    <MenuIcon />
                </div>

                <div className="flex-fill"></div>
                {aXNzdXBlcmFkbWlu && (
                    <div className="me-3">
                        <select
                            value={currentOrg}
                            className="form-select"
                            onChange={(e) => {
                                setCurrentOrg(e.target.value);
                                window.location.reload()
                            }}
                        >
                            <option key="0" value="" disabled>
                                Select Org Id
                            </option>
                            {orgList.map((org) => (
                                <option key={org.id} value={org.id}>
                                    {org.companyName}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                <button
                    className="btn btn-outline-primary"
                    onClick={() => {
                        logout();
                        history.replace(LOGIN_ROUTE);
                    }}
                >
                    Sign Out
                </button>

                {/* <div className="btn p-0 ms-2" style={navButtonStyle}>
                    <SearchIcon />
                </div>

                <div className="btn p-0 ms-2" style={navButtonStyle}>
                    <BellIcon />
                </div> */}

                <div
                    className="d-flex ms-2"
                    style={{
                        ...navButtonStyle,
                        flexBasis: "auto",
                        width: "auto",
                    }}
                >
                    <div className="rounded-circle d-flex align-items-center justify-content-center" style={{width:"32px",height:"32px",backgroundColor:"var(--ui-3)"}}>
                        <i className="material-icons" style={{color:"var(--ui-4)"}}>person</i>
                    </div>
                    <div className="ms-2 me-4 text-body-2 text-2">
                        {userName}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardNavbar;
